import { configureStore } from '@reduxjs/toolkit'
import { appApi } from 'slices/api'
import { childDuplicate } from 'slices/duplicateChildSlice'

export const store = configureStore({
  reducer: {
    [appApi.reducerPath]: appApi.reducer,
    [childDuplicate.reducerPath]: childDuplicate.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(appApi.middleware)
})
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
